import { ShipWheel } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ShipWheelIcon = createLucideIcon(ShipWheel);
